// extracted by mini-css-extract-plugin
export var banner = "_ge-0";
export var closeButton = "_ge-2";
export var greenCheckmark = "_ge-3";
export var hereLink = "_ge-4";
export var titleIcon = "_ge-1";